import React, {useEffect } from 'react'
import {connect } from 'react-redux';
import {getList} from '../../actions/announcement'
import styles from './styles.module.scss'
import Loader from 'react-loader'
import moment from 'moment';



const List = ({data, loading, getList, history}) => {
  

  useEffect(() => {
    getList()
  }, [])
  

  const goToItemHandler = (id) => (e) => {
    history.push(`/announcement/${id}`)
  }


  const renderRow = (item) => {
    return (
      <tr key={item.id} onClick={goToItemHandler(item.postid)}>
        <td>{item.name}</td>
        <td>{item.sender}</td>
        <td>{moment(item.posted).format('DD.MM.YYYY')}</td>
      </tr>
    )
  }

  if (loading) return <Loader/>

  return (
    <div className={styles.listWrap}>
      <h1>Объявления</h1>
      <table>
        <thead>
          <tr>
            <th>Название</th>
            <th>Отправитель</th>
            <th>Дата</th>
          </tr>
        </thead>
        <tbody>
          {data?.map(renderRow)}
        </tbody>
      </table>
    </div>
  )
}

const mapStateToProps = (state) => ({
  data: state.announcement.list,
  loading: state.announcement.loading
});


export default connect(mapStateToProps, { getList })(List) 


